import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createNature, updateNature } from '@/store/thunks/natureThunks';
import type { Nature } from '@/types';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  nom: Yup.string().required('Nom obligatoire'),
  unite: Yup.string().required('Unité obligatoire'),
});

interface NatureFormProps {
  nature?: Nature | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function NatureForm({ nature, type, onClose, onSuccess }: NatureFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      nom: nature?.nom ?? '',
      unite: nature?.unite ?? '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (type === 'update' && nature?.id) {
        const res = await dispatch(updateNature({ ...nature, ...values }));
        if (updateNature.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createNature(values));
        if (createNature.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input label="Nom" id="nom" {...formik.getFieldProps('nom')} error={formik.touched.nom ? formik.errors.nom : undefined} />
      <Input label="Unité" id="unite" {...formik.getFieldProps('unite')} error={formik.touched.unite ? formik.errors.unite : undefined} />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
        <Button type="submit" loading={formik.isSubmitting}>{type === 'update' ? 'Modifier' : 'Créer'}</Button>
      </div>
    </form>
  );
}
